module.exports = __webpack_public_path__ + "img/asset.ff463088.webp";